import { render, staticRenderFns } from "./dataTeste.vue?vue&type=template&id=5b09ff41&scoped=true&"
import script from "./dataTeste.vue?vue&type=script&lang=js&"
export * from "./dataTeste.vue?vue&type=script&lang=js&"
import style0 from "./dataTeste.vue?vue&type=style&index=0&id=5b09ff41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b09ff41",
  null
  
)

export default component.exports